import { Column, Divider } from 'further-ui/components/Layout';
import { Theme, Typography } from '@mui/material';
import React, { PropsWithChildren } from 'react';

type Props = {
  title?: React.ReactNode;
  withoutBottomDivider?: boolean;
  spacing?: keyof Theme['spacingSizes'];
};

const PageSection: React.FC<PropsWithChildren<Props>> = ({
  title,
  children,
  spacing = 'sm',
  withoutBottomDivider = false,
}) => {
  return (
    <Column spacing="lg">
      <Column spacing={spacing}>
        {title ? (
          <Typography variant="h5" component="div">
            {title}
          </Typography>
        ) : null}
        {children}
      </Column>
      {withoutBottomDivider ? null : <Divider />}
    </Column>
  );
};

export default PageSection;
